var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"kk-arrow clickable biennaleTetriary",style:(_vm.btnStyle)},_vm.$listeners),[_c('v-icon',{attrs:{"size":_vm.$vuetify.breakpoint.smAndUp ? 32 : 22}},[_vm._v("$vuetify.icons.Arrrow")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }